import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { Observable, of, switchMap } from 'rxjs'
import { SavedIlsService } from '../shared/services/savedIls.service'
import { TokenService } from '@monorepo/auth'

/**
 * The LoginGuard is responsible for protecting the login page from authenticated users.
 * It ensures that only non-authenticated users can access the login page.
 * If an authenticated user tries to access the login page, they will be redirected to the previous URL.
 * If no previous URL exists, the user will be redirected to the default URL.
 */

@Injectable({
  providedIn: 'root',
})
export class LoginGuard {
  private tokenService = inject(TokenService);
  private router = inject(Router);
  private savedIlsService = inject(SavedIlsService);

  constructor() {
    console.log('Loginguard')
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.tokenService.getUserObservable().pipe(
      switchMap((user) => {
        const urlToNavigateTo = this.getIlsIdFromUrl(state.url)
        const savedUrl = this.savedIlsService.previousUrl$.value ?? ''
        console.log('urlToNavigateTo', urlToNavigateTo)
        console.log('savedUrl', savedUrl)
        if (user) {
          console.log('User found.')
          if (urlToNavigateTo === savedUrl) {
            console.log('need to redirect to previous URL.')
            // used if the user goes from :ilsId to /login/:ilsId when they are already logged in
            this.router.navigate([savedUrl])
            return of(false)
          } else {
            console.log('User is trying to go to the login page of another ils. Allow it, and clear the ilsId.')
            this.tokenService.signOut()
            this.savedIlsService.saveUrl(urlToNavigateTo)
            this.router.navigateByUrl('/login/' + urlToNavigateTo)
            return of(true)
          }
        } else {
          console.log(
            "User not found, allow going to the login page of the ilsId they're trying to access, regardless of anything saved.",
          )
          this.savedIlsService.saveUrl(urlToNavigateTo)
          this.tokenService.signOut()
          // this.router.navigate(['login/' + urlToNavigateTo], { relativeTo: this.activatedRoute.parent })
          return of(true)
        }
      }),
    )
  }

  private getIlsIdFromUrl(url: string): string {
    const urlParts = url.split('/')
    return urlParts[urlParts.length - 1]
  }
}
